import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=8c1dadf0&"
import script from "./Language.vue?vue&type=script&lang=ts&"
export * from "./Language.vue?vue&type=script&lang=ts&"
import style0 from "./Language.vue?vue&type=style&index=0&id=8c1dadf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports